export interface MainMenuSystemMessageLayout {
  stripHeight: number;
  messageCenterX: number;
  messageTop: number;
  messageWidth: number;
  modeSectionY: number;
  searchButtonY: number;
}

const STRIP_Y = 274;
const STRIP_MIN_H = 184;
const STRIP_MAX_H = 210;
// 62px header + message + 76px action/footer space.
const STRIP_VERTICAL_CHROME = 138;
const STRIP_TO_MODES_GAP = 16;
const MODES_Y_WITHOUT_MESSAGE = 286;
const SEARCH_OFFSET = 580;
// The body owns the full card width because the action is now in a separate footer row.
const MESSAGE_LEFT = 24;
const MESSAGE_RIGHT = 648;
const MESSAGE_TOP = 62;

/** Keep wrapped system announcements inside their card and move all following content together. */
export function mainMenuSystemMessageLayout(
  visible: boolean,
  wrappedMessageHeight: number,
): MainMenuSystemMessageLayout {
  if (!visible) {
    return {
      stripHeight: STRIP_MIN_H,
      messageCenterX: (MESSAGE_LEFT + MESSAGE_RIGHT) / 2,
      messageTop: MESSAGE_TOP,
      messageWidth: MESSAGE_RIGHT - MESSAGE_LEFT,
      modeSectionY: MODES_Y_WITHOUT_MESSAGE,
      searchButtonY: MODES_Y_WITHOUT_MESSAGE + SEARCH_OFFSET,
    };
  }

  const contentHeight = Number.isFinite(wrappedMessageHeight)
    ? Math.max(0, wrappedMessageHeight)
    : 0;
  const stripHeight = Math.min(
    STRIP_MAX_H,
    Math.max(STRIP_MIN_H, Math.ceil(contentHeight + STRIP_VERTICAL_CHROME)),
  );
  const modeSectionY = STRIP_Y + stripHeight + STRIP_TO_MODES_GAP;
  return {
    stripHeight,
    messageCenterX: (MESSAGE_LEFT + MESSAGE_RIGHT) / 2,
    messageTop: MESSAGE_TOP,
    messageWidth: MESSAGE_RIGHT - MESSAGE_LEFT,
    modeSectionY,
    searchButtonY: modeSectionY + SEARCH_OFFSET,
  };
}
